import { addDays, addMonths } from "date-fns";
import { formatPrecisaoFloat } from "../../../utils";

const subtotalItem = (item) =>
  formatPrecisaoFloat(
    item.subtotal || item.quantidade * (item.valorUnitario || item.valor)
  );

export function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export function verificarNotasEmitidasHoje(notas, operacaoFiscalId) {
  const notasHoje = notas.filter(
    (item) => item.operacaoFiscalId === operacaoFiscalId
  );
  return notasHoje.length > 0;
}

export function getIndexItemMaisCaro(lista) {
  return lista.reduce(
    (maxIndex, currentItem, currentIndex, array) =>
      subtotalItem(currentItem) > subtotalItem(array[maxIndex])
        ? currentIndex
        : maxIndex,
    0
  );
}

export function formatProdutosTotalizadores(
  name,
  nfSaidaItens,
  valueInputReal,
  totalNota
) {
  const valueInput = parseFloat(valueInputReal || 0);
  let listaAtualizada = nfSaidaItens.map((item) => {
    const valorProporcional =
      formatPrecisaoFloat((subtotalItem(item) * 100) / totalNota) / 100;
    return {
      ...item,
      [name]:
        valueInput > 0
          ? formatPrecisaoFloat(valorProporcional * valueInput)
          : 0,
    };
  });
  ajustarDiferenca(name, valueInput, listaAtualizada);
  return listaAtualizada;
}

export function totalItensLista(listaNfSaidaProdutos) {
  if (listaNfSaidaProdutos?.length) {
    return listaNfSaidaProdutos.reduce(
      (prevVal, elem) => formatPrecisaoFloat(prevVal + subtotalItem(elem)),
      0
    );
  }
}

export function totalVenda(nfSaida, nfSaidaItens, calculoTotalizadores) {
  const freteNota =
    nfSaida?.freteCompoeNota === true ? parseFloat(nfSaida?.frete ?? 0) : 0;
  const subtotalProdutos = totalItensLista(nfSaidaItens);
  const subtotalDesconto = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "desconto"
  );
  const subtotalAcrescimo = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "acrescimo"
  );
  const subtotalDespesas = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "despesas"
  );
  return formatPrecisaoFloat(
    (subtotalProdutos || 0) -
      (subtotalDesconto || 0) +
      (subtotalAcrescimo || 0) +
      (subtotalDespesas || 0) +
      (freteNota || 0) + 
      (nfSaida?.subtotalTributosIncidentes || 0)
  );
}

export function calculaSubtotalParaChave(lista, tipoOperacao, chave) {
  if (lista?.length > 0) {
    const valorCalculado = lista.reduce((acumulador, objetoAtual) => {
      return formatPrecisaoFloat(
        acumulador + parseFloat(objetoAtual[chave] ?? 0)
      );
    }, 0);
    return tipoOperacao !== chave ? valorCalculado : 0;
  }
}

export function totalPagamentos(nfSaidaPagamentos) {
  if (nfSaidaPagamentos?.length) {
    return nfSaidaPagamentos.reduce(
      (prevVal, elem) => formatPrecisaoFloat(prevVal + elem.valorTitulo),
      0
    );
  }
}

export function mapearEndereco(endereco) {
  return {
    ...endereco,
    cidade: endereco?.cidade?.nome,
    codigoIbge: endereco?.cidade?.codigoIbge,
    estado: endereco?.cidade?.estado?.sigla,
    estadoId: endereco?.cidade?.estadoId,
    pais: endereco?.pais?.nome,
    bacen: endereco?.pais?.codigo,
  };
}

export function mapearEnderecos(enderecos) {
  return enderecos.map((endereco) => mapearEndereco(endereco));
}

export function encontrarEstado(estados, estadoId) {
  if (estados.length) {
    return estados.find((estado) => estado.id === estadoId)?.sigla;
  }
  return "";
}

export function encontrarEnderecoPadrao(enderecos) {
  return enderecos.find((endereco) => endereco.padrao === true);
}

export function calcularPrecoProduto(
  produto,
  tabelaVenda = null,
  tipoTabela = null,
) {
  const preco = produto?.precoVenda || 0;
  if (tipoTabela === "meioPagamento" || tabelaVenda.tipoTabela === "POR_PRODUTO") {
    let tabelaVendaProduto = tabelaVenda;
    if (tabelaVenda?.itens?.length) {
      tabelaVendaProduto = tabelaVenda.itens.find(
        ({ estProdutoId }) =>
          estProdutoId === produto.id || estProdutoId === produto?.produtoId
      );
    }
    if (
      tabelaVendaProduto &&
      produto?.quantidade >= tabelaVendaProduto?.quantidadeMinima
    ) {
      const valor = formatPrecisaoFloat(tabelaVendaProduto.precoPraticado);
      return {
        ...produto,
        valor,
        subtotal: valor * (parseFloat(produto?.quantidade) || 1),
      };
    }
    return produto;
  } else {
    const porcentagem = formatPrecisaoFloat(tabelaVenda.fator / 100);
    const valorDescontoAcrescimo = formatPrecisaoFloat(preco * porcentagem);
    if (tabelaVenda.operacao === "subtrair") {
      return {
        ...produto,
        descontoPorcentagem: tabelaVenda.fator,
        desconto: valorDescontoAcrescimo,
        valor: preco,
        subtotal: preco * (parseFloat(produto?.quantidade) || 1),
      };
    } else {
      return {
        ...produto,
        despesas: valorDescontoAcrescimo,
        valor: preco,
        subtotal: preco * (parseFloat(produto?.quantidade) || 1),
      };
    }
  }
}

export function parcelaData(indice, data, intervaloDias) {
  const dias = indice * (intervaloDias ?? 1);
  const meses = Math.floor(dias / 30);
  const diasRestantes = dias % 30;
  const dataAtualizada = addMonths(new Date(data), meses);
  const dataFinal = addDays(dataAtualizada, diasRestantes);
  return dataFinal;
}

export function calcularLimiteCreditoUltrapassado(
  nfSaidaPagamentos,
  limiteDisponivel
) {
  let total = 0;
  for (const pagamento of nfSaidaPagamentos) {
    total += pagamento.valorTitulo;
    if (total > limiteDisponivel) return true;
  }
  return false;
}

export function csoValueFormat(csoSimplesList, produto) {
  if (csoSimplesList) {
    const objeto = csoSimplesList?.find(
      (objeto) => objeto?.codigo == produto?.tributosIcmsCsosn
    );
    return objeto ? `${objeto.codigo} - ${objeto.descricao}` : "";
  }
}

export function compararPagamentosTotalNfSaida(nfSaida) {
  return nfSaida?.totalVenda - nfSaida?.totalPagamentos > 0;
}

export function GeraCodigoNumerico(dataEmissao) {
  const date = new Date(
    dataEmissao.getFullYear(),
    dataEmissao.getMonth(),
    dataEmissao.getDate(),
    dataEmissao.getHours(),
    dataEmissao.getMinutes(),
    dataEmissao.getSeconds(),
    dataEmissao.getMilliseconds()
  );
  const utcMilliseconds = date.getTime();
  const codigo =
    utcMilliseconds.toString().slice(4, 10) +
    utcMilliseconds.toString().slice(16);
  return codigo;
}

export function Calculo_DV11(strNumero) {
  if (!strNumero) {
    return "";
  }
  let total = 0;
  let weight = 2;
  for (let i = strNumero.length - 1; i >= 0; i--) {
    const digit = parseInt(strNumero[i], 10);
    total += digit * weight;
    weight = (weight + 1) % 9;
  }
  const remainder = total % 11;
  return remainder === 0 || remainder === 1 ? "0" : (11 - remainder).toString();
}

export function formatProdutosTotalizadoresDto(
  nfSaidaItens,
  totalNota,
  nfSaida
) {
  const { acrescimo = 0, despesas = 0, desconto = 0 } = nfSaida;
  let listaAtualizada = nfSaidaItens.map((item) => {
    const valorProporcional =
      formatPrecisaoFloat((subtotalItem(item) * 100) / totalNota) / 100;
    const novosValores = {
      acrescimo: formatPrecisaoFloat(valorProporcional * acrescimo),
      despesas: formatPrecisaoFloat(valorProporcional * despesas),
      desconto: formatPrecisaoFloat(valorProporcional * desconto),
    };
    return {
      ...item,
      ...novosValores,
    };
  });
  ajustarDiferenca("acrescimo", acrescimo, listaAtualizada);
  ajustarDiferenca("despesas", despesas, listaAtualizada);
  ajustarDiferenca("desconto", desconto, listaAtualizada);

  return listaAtualizada;
}

function ajustarDiferenca(key, valorTotal, listaAtualizada) {
  const subtotal = calculaSubtotalParaChave(listaAtualizada, "", key);
  if (valorTotal !== subtotal && valorTotal > 0 && subtotal > 0) {
    const indiceItemMaisCaro = getIndexItemMaisCaro(listaAtualizada);
    const diferenca = formatPrecisaoFloat(valorTotal - subtotal);
    listaAtualizada[indiceItemMaisCaro][key] += diferenca;
  }
}

export function calculoDesconto(itens, nfSaida, porCemParaDecimal = true) {
  const total = formatPrecisaoFloat(totalItensLista(itens));

  let resultado = 0;
  if (porCemParaDecimal) {
    const descontoPorcentagem = parseFloat(nfSaida?.descontoPorcentagem ?? 0);
    resultado = formatPrecisaoFloat((descontoPorcentagem / 100) * total, 3);
  } else {
    const desconto = parseFloat(nfSaida?.desconto ?? 0);
    resultado = formatPrecisaoFloat(
      (desconto / formatPrecisaoFloat(total)) * 100,
      3
    );
  }
  return resultado || 0;
}

export function limparCampoTotalizador(name, itens) {
  if (!itens?.length) return;
  return itens.map((item) => ({
    ...item,
    [name]: 0,
  }));
}

export function formatTotalItemAcrescimo(item, acrescimoPagamento) {
  const { quantidade, precoVenda } = item;
  const valorUnitarioAcrescimo =
    acrescimoPagamento
      ? precoVenda +
        formatPrecisaoFloat(
          precoVenda * (acrescimoPagamento / 100)
        )
      : precoVenda;
  return {
    valorUnitario: valorUnitarioAcrescimo,
    totalItem: valorUnitarioAcrescimo * quantidade
  }
}

export function validarTabelaVendaCliente(tabelaVenda, produtoId) {
  if (tabelaVenda) {
    return tabelaVenda.itens.length 
    ? tabelaVenda.itens.find(
        ({ estProdutoId }) => produtoId === estProdutoId
      )
    : null;
  }

  return false;
}

export function validarTabelaVendaMeioPagamento(tabelasVenda, meioPagamentoId) {
  if (tabelasVenda) {
    const tabelaVenda = tabelasVenda[0]?.tabelaVenda;
    return tabelaVenda?.meioPagamentoIds.length
      ? tabelaVenda?.meioPagamentoIds.find(
        ({ fatMeioPagamentoId }) => fatMeioPagamentoId === meioPagamentoId
      )
      : null;
  } 
  
  return false;
}

export function validarTabelaTodosProdutosMeioPagamento(tabelasVenda, meioPagamentoId) {
  if (tabelasVenda?.length > 0) {
    return tabelasVenda.find((tabela) => 
      tabela.meioPagamentoIds?.find(
        ({ fatMeioPagamentoId }) => fatMeioPagamentoId === meioPagamentoId)
      );
  }

  return false;
}
